import React from 'react';
interface PatternSectionProps {
  hideAudio?: boolean;
}
export const PatternSection: React.FC<PatternSectionProps> = ({
  hideAudio = false
}) => {
  const symptoms = ['Problemas digestivos', 'Dermatitis recurrente', 'Alergias crónicas', 'Baja energía'];
  return <section id="pattern-section" className="py-16 md:py-24 px-4 relative overflow-hidden" style={{
    backgroundColor: '#F8F6F1'
  }} data-id="element-905">
      <div className="absolute inset-0 opacity-5" data-id="element-906">
        <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full blur-3xl" style={{
        backgroundColor: '#2F5D50'
      }} data-id="element-907" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 rounded-full blur-3xl" style={{
        backgroundColor: '#6DAA7F'
      }} data-id="element-908" />
      </div>

      <div className="relative max-w-3xl mx-auto" data-id="element-909">
        <div className="mb-10" data-id="element-910">
          <p className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase mb-4" style={{
          color: '#6DAA7F'
        }} data-id="element-911">
            Atención
          </p>

          {/* Audio Player */}
          {!hideAudio && <div className="w-full max-w-xl rounded-2xl px-5 py-4 flex items-center gap-4 relative overflow-hidden mb-8" style={{
          background: 'linear-gradient(135deg, #2F5D50 0%, #3d7a68 40%, #4a9680 70%, #2F5D50 100%)',
          boxShadow: '0 0 24px 6px rgba(47,93,80,0.4), 0 0 8px 2px rgba(47,93,80,0.3)',
          animation: 'audioGlow 2.5s ease-in-out infinite'
        }} data-id="element-912">
              <span className="pointer-events-none absolute inset-0 rounded-2xl" style={{
            background: 'linear-gradient(105deg, transparent 35%, rgba(255,255,255,0.18) 50%, transparent 65%)',
            animation: 'shimmerSweep 2.8s linear infinite'
          }} data-id="element-913" />
              <style data-id="element-914">{`
              @keyframes audioGlow {
                0%, 100% { box-shadow: 0 0 20px 4px rgba(47,93,80,0.45), 0 0 8px 2px rgba(47,93,80,0.35); }
                50% { box-shadow: 0 0 36px 10px rgba(47,93,80,0.75), 0 0 14px 4px rgba(47,93,80,0.55); }
              }
              @keyframes shimmerSweep {
                0% { transform: translateX(-100%); }
                100% { transform: translateX(200%); }
              }
            `}</style>
              <div className="w-11 h-11 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 shadow-md border border-white/30 relative z-10" data-id="element-915">
                <span className="text-xl" data-id="element-916">🎧</span>
              </div>
              <div className="flex-1 min-w-0 relative z-10" data-id="element-917">
                <p className="text-xs font-extrabold text-white uppercase tracking-widest mb-1.5 drop-shadow" data-id="element-918">
                  🔊 Mensaje importante
                </p>
                <audio id="pattern-audio" controls className="w-full h-8" style={{
              accentColor: '#fff'
            }} data-id="element-919">
                  <source src="https://ydgkmdmvhrniztrhtrxq.supabase.co/storage/v1/object/sign/audio%20receta/freepik__si-tu-mascota-presenta-alguno-de-estos-s_ntomas_-es-importante-que-prestes-atenci__2235.mp3?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV80NDNkYTY1ZS1iYWM1LTQyYWQtODMzNS1iNWE4N2M0NDYxNmQiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJhdWRpbyByZWNldGEvZnJlZXBpa19fc2ktdHUtbWFzY290YS1wcmVzZW50YS1hbGd1bm8tZGUtZXN0b3Mtc19udG9tYXNfLWVzLWltcG9ydGFudGUtcXVlLXByZXN0ZXMtYXRlbmNpX18yMjM1Lm1wMyIsImlhdCI6MTc3MjI0OTg3NiwiZXhwIjoxODAzNzg1ODc2fQ.AgpW4Q62gMYLuNOsBFqze4R2cYz2u4XBUwSw38m1UGk" type="audio/mpeg" data-id="element-920" />
                  Tu navegador no soporta el elemento de audio.
                </audio>
              </div>
            </div>}

          <h2 className="text-2xl md:text-4xl font-black leading-tight uppercase tracking-tight" style={{
          color: '#2F5D50'
        }} data-id="element-921">
            Lo que acabas de escuchar{' '}
            <span style={{
            color: '#6DAA7F'
          }} data-id="element-922">
              no es una opinión.
            </span>
          </h2>
        </div>

        <p className="text-lg md:text-xl text-gray-600 mb-10 leading-relaxed" data-id="element-923">
          Es el resultado de años observando el mismo patrón:
        </p>

        <div className="mb-10 space-y-3" data-id="element-924">
          <p className="text-sm font-semibold text-gray-400 uppercase tracking-widest mb-4" data-id="element-925">
            Perros con:
          </p>
          {symptoms.map((symptom, i) => <div key={i} className="flex items-center gap-3 bg-white border rounded-lg px-5 py-4" style={{
          borderColor: '#6DAA7F'
        }} data-id="element-926">
              <span className="w-2 h-2 rounded-full flex-shrink-0" style={{
            backgroundColor: '#6DAA7F'
          }} data-id="element-927" />
              <span className="font-semibold text-base md:text-lg" style={{
            color: '#2F5D50'
          }} data-id="element-928">
                {symptom}
              </span>
            </div>)}
        </div>

        <p className="text-base md:text-lg text-gray-600 italic mb-12 pl-5" style={{
        borderLeft: '4px solid #6DAA7F'
      }} data-id="element-929">
          Que mejoran cuando se corrige la alimentación desde la raíz.
        </p>

        <div className="w-16 h-1 mb-12 rounded-full" style={{
        backgroundColor: '#6DAA7F'
      }} data-id="element-930" />

        <div className="rounded-2xl p-6 md:p-8 mb-8" style={{
        backgroundColor: 'rgba(47,93,80,0.08)',
        border: '1px solid rgba(47,93,80,0.25)'
      }} data-id="element-931">
          <p className="text-xl md:text-3xl font-black leading-tight mb-2" style={{
          color: '#2F5D50'
        }} data-id="element-932">
            El 70–80% del sistema inmune de tu perro
          </p>
          <p className="text-xl md:text-3xl font-black leading-tight text-gray-800" data-id="element-933">
            vive en el intestino.
          </p>
        </div>

        <div className="text-center" data-id="element-934">
          <p className="text-lg md:text-2xl font-bold text-gray-700 leading-relaxed" data-id="element-935">
            Y cuando el intestino está inflamado…
          </p>
          <p className="text-xl md:text-3xl font-black mt-2" style={{
          color: '#C0392B'
        }} data-id="element-936">
            Todo empieza a fallar.
          </p>
        </div>
      </div>
    </section>;
};